// @ts-check
/* eslint-disable @typescript-eslint/no-this-alias */

import angular from 'angular';

/**
 * @constructor
 */
export default function Dialog() {
  const self = this;
  self.id = 0;
  self.loading = true;
  self.strategyName = null;
  self.title = '';
  self.url = '';
  self.elm = null;
  self.openState = 'init';
  self.preOpened = false;
  self.contentscope = {};

  self.actions = {
    close: {
      type: 'button',
      label: 'Close',
      css: 'btn btn-default',
      method(dialog) {
        self.close();
      },
    },
  };

  /**
   * setElm
   *
   * @param elm
   */
  self.setElm = function (elm) {
    self.elm = elm;
    self.syncEvents();

    // If open was called before the elm is set, then we should open now
    if (self.preOpened) {
      self.open();
    }
  };

  /**
   * getDirectiveName
   *
   * @returns {string}
   */
  self.getDirectiveName = function () {
    return self.strategyName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  };

  /**
   * setAction
   *
   * @param actionName
   * @param action
   */
  self.setAction = function (actionName, action) {
    if (self.actions[actionName]) {
      self.actions[actionName] = angular.extend(self.actions[actionName], action);
    } else {
      self.actions[actionName] = action;
    }

    RcmDialog.eventManager.trigger('dialog.setAction', self);
  };

  /**
   * getAction
   *
   * @param actionName
   * @returns {*}
   */
  self.getAction = function (actionName) {
    if (self.actions[actionName]) {
      return self.actions[actionName];
    }

    return null;
  };

  /**
   * open
   */
  self.open = function () {
    RcmDialog.eventManager.trigger('dialog.open', self);

    // Set flag if elm is not ready
    if (!self.elm) {
      self.preOpened = true;
    }

    if (self.elm && self.openState !== 'open') {
      self.openState = 'open';
      self.loading = true;

      self.elm.modal('show');
    }
  };

  /**
   * If special action is used for close, we should use it
   */
  self.closeAction = function () {
    if (self.actions.close) {
      RcmDialog.eventManager.trigger('dialog.close', self);
      if (self.elm && self.openState !== 'closed') {
        self.actions.close.method(self);
      }
    }
  };

  /**
   * close
   */
  self.close = function () {
    RcmDialog.eventManager.trigger('dialog.close', self);

    // Spam protection
    if (self.elm && self.openState !== 'closed') {
      self.openState = 'close';
      self.elm.modal('hide');
    }
  };

  /**
   * remove
   */
  self.remove = function () {
    RcmDialog.removeDialog(self.id);
  };

  /**
   * syncEvents
   */
  self.syncEvents = function () {
    if (self.elm.modal) {
      self.elm.on('show.bs.modal', function (event) {
        self.openState = 'opening';
      });

      self.elm.on('shown.bs.modal', function (event) {
        self.openState = 'opened';
      });

      self.elm.on('hide.bs.modal', function (event) {
        self.openState = 'closing';
      });

      self.elm.on('hidden.bs.modal', function (event) {
        self.openState = 'closed';
        // The close action happens after closing
        self.closeAction();
        self.remove();
      });
    }
  };
}
